import { BASE_URL } from "./config";

async function request(endpoint, { method = "GET", token, body, headers = {}, ...customOptions } = {}) {
    const authToken = token || localStorage.getItem("token") || sessionStorage.getItem("token");

    const requestHeaders = {
        ...headers,
    };

    if (authToken) {
        requestHeaders["Authorization"] = `Bearer ${authToken}`;
    }

    if (body && !(body instanceof FormData) && !(body instanceof URLSearchParams)) {
        requestHeaders["Content-Type"] = "application/json";
    }

    const config = {
        method,
        headers: requestHeaders,
        ...customOptions,
    };

    if (body) {
        config.body = typeof body === "object" && !(body instanceof FormData) && !(body instanceof URLSearchParams)
            ? JSON.stringify(body)
            : body;
    }

    const url = endpoint.startsWith("http") ? endpoint : `${BASE_URL}${endpoint}`;
    const res = await fetch(url, config);

    if (!res.ok) {
        let errorMsg = `API Error: ${res.status}`;
        try {
            const errData = await res.json();
            errorMsg = errData.message || errData.error || errorMsg;
        } catch (e) {
            // ignore
        }
        throw new Error(errorMsg);
    }

    return res.json();
}

export const client = {
    get: (endpoint, options = {}) => request(endpoint, { ...options, method: "GET" }),
    post: (endpoint, body, options = {}) => request(endpoint, { ...options, method: "POST", body }),
    put: (endpoint, body, options = {}) => request(endpoint, { ...options, method: "PUT", body }),
    delete: (endpoint, options = {}) => request(endpoint, { ...options, method: "DELETE" }),
};
